import { resetAll } from "../slices/baseSlice";

export default function sessionMiddleware() {
  return ({ dispatch }) =>
    (next) =>
    (action) => {
      if (action?.payload?.status === 401) {
        dispatch(resetAll());
      }
      return next(action);
    };
}
